<template>
  <router-view />
</template>
<script>
export default {
  name: "marketingCenter",
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.marketingCenter {
  position: relative;
}
</style>
